import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class CboService extends Token {
  findAll() {
    return axios({
      method: "get",
      url: this.api_url + "cbo",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    }).then((res) => res.data);
  }

  create(cbo) {
    return axios({
      method: "post",
      url: this.api_url + "cbo",
      withCredentials: true,
      data: cbo,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    });
  }
  update(cbo) {
    return axios({
      method: 'put',
      url: this.api_url + 'cbo/' + cbo.id,
      withCredentials: true,
      data: cbo,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });
  }

  delete(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'cbo/' + id,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }
}
